// Helper function to format large numbers compactly
export const formatItemCount = (count: number): string => {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1).replace(/\.0$/, '')}M items`;
  } else if (count >= 1000) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}K items`;
  } else {
    return `${count} items`;
  }
};
